<template>
  <div class="flex flex-col gap-12 md:grid md:grid-cols-2 md:gap-8">
    <div
      v-if="marketsWithoutBackbox.length"
      class="flex flex-col gap-12 md:flex-row md:items-center"
    >
      <span class="body-2">
        {{ i18n(translations.withoutBackbox) }}
      </span>

      <ul class="flex list-none flex-wrap gap-4">
        <li v-for="market in marketsWithoutBackbox" :key="market.countryCode">
          <RevButtonBase
            :data-qa="`flag-${market.countryCode}`"
            :data-test="`flag-link-${market.countryCode}`"
            target="_blank"
            :to="market.productPageLink"
          >
            <div
              class="text-static-danger-hi body-2 flex items-center justify-between border border-1 px-6 py-2"
            >
              <Flag
                class="mr-8"
                :country-code="market.countryCode as MarketCountryCode"
                size="m"
              />
              {{ market.countryCode }}
            </div>
          </RevButtonBase>
        </li>
      </ul>
    </div>

    <div
      v-if="marketsWithBackbox.length"
      class="flex flex-col gap-12 md:flex-row md:items-center"
    >
      <span class="body-2">
        {{ i18n(translations.withBackbox) }}
      </span>

      <ul class="flex list-none flex-wrap gap-4">
        <li v-for="market in marketsWithBackbox" :key="market.countryCode">
          <RevButtonBase
            :data-qa="`flag-${market.countryCode}`"
            :data-test="`flag-link-${market.countryCode}`"
            target="_blank"
            :to="market.productPageLink"
          >
            <div
              class="body-2 flex items-center justify-between border border-1 px-6 py-2"
            >
              <Flag
                class="mr-8"
                :country-code="market.countryCode as MarketCountryCode"
                size="m"
              />
              {{ market.countryCode }}
            </div>
          </RevButtonBase>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import type {
  Listing,
  MarketListing,
} from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants/listings.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonBase } from '@ds/components/ButtonBase'

import translations from '../MinifiedInfo.translations'

const i18n = useI18n()

const props = defineProps<{
  listing: Listing
}>()

function formatMarketInfo(countryCode: string, market: MarketListing) {
  return {
    countryCode,
    productPageLink: market.productPageLink?.href,
  }
}

const marketsWithBackbox = computed(() =>
  Object.keys(props.listing.markets.withBackbox).map((countryCode) =>
    formatMarketInfo(
      countryCode,
      props.listing.markets.withBackbox[countryCode as MarketCountryCode],
    ),
  ),
)

const marketsWithoutBackbox = computed(() => [
  ...Object.keys(props.listing.markets.withoutBackbox).map((countryCode) =>
    formatMarketInfo(
      countryCode,
      props.listing.markets.withoutBackbox[countryCode as MarketCountryCode],
    ),
  ),
  ...Object.keys(props.listing.markets.offline).map((countryCode) =>
    formatMarketInfo(
      countryCode,
      props.listing.markets.offline[countryCode as MarketCountryCode],
    ),
  ),
])
</script>
